@if (campaignDetail().afterSalesContent; as campaign) {
    <section>
        <ui-m030-c020-teaser-allrounder
            [image]="campaign.heroImage.url"
            [imageAlt]="campaign.heroImage.alt || campaign.teaserHeadline"
            [isFirstView]="true"
        >
            <h1 headline>{{ campaign.teaserHeadline }}</h1>
            <h2 class="mb-24" subheadline>{{ dealerLocationHeadline() }}</h2>

            <ng-container cta>
                <div class="flex">
                    @if (showOnlyPrimaryButton()) {
                        @if (featuredElement(); as d) {
                            <a
                                class="button-primary md:w-auto"
                                [hyundaiRouterLink]="d.itemType === 'service' ? d.link : undefined"
                                [trackingElTarget]="d.itemType === 'service' ? d.link : undefined"
                                tracking
                                trackingElLabel="Service Request"
                                trackingElType="button"
                                trackingEvent="engagement_click"
                            >
                                Terminvereinbarung
                            </a>
                        }
                    } @else {
                        <div class="flex flex-col gap-16">
                            <a
                                ui-m010-c010-icon-double-cta
                                class="block w-full md:w-auto"
                                [hyundaiRouterLink]="'tel:' + dealer().phone"
                                [trackingElTarget]="'tel:' + dealer().phone"
                                tracking
                                trackingElLabel="Service Request"
                                trackingElType="button"
                                trackingEvent="engagement_click"
                            >
                                Jetzt Termin vereinbaren
                                <ng-container subtext>{{ dealer().phone }}</ng-container>
                            </a>

                            @if (featuredElement(); as d) {
                                <a
                                    ui-m010-c020-icon-link
                                    class="inline-block"
                                    [hyundaiRouterLink]="d.itemType === 'service' ? d.link : undefined"
                                    [trackingElTarget]="d.itemType === 'service' ? d.link : undefined"
                                    tracking
                                    trackingElLabel="Service Request"
                                    trackingElType="basic link"
                                    trackingEvent="engagement_click"
                                >
                                    Terminvereinbarung
                                </a>
                            }
                        </div>
                    }
                </div>
            </ng-container>
        </ui-m030-c020-teaser-allrounder>
    </section>

    @if (campaign.heroImageCaption) {
        <div class="inner-page-wrapper relative">
            <span class="leading-21 absolute top-0 py-5 text-14 text-grey-400">
                {{ campaign.heroImageCaption }}
            </span>
        </div>
    }

    @if (campaign.afterSalesServicesMapped.length > 0) {
        <section class="md:pt-40">
            <div class="flex flex-col-reverse md:flex-col">
                <h2
                    class="max-w-[1280px] px-24 text-20 leading-25 text-black md:mx-auto md:text-center md:text-34 md:leading-41"
                >
                    Hyundai Service-Highlights der Saison
                </h2>
                @if (featuredElement(); as d) {
                    <div>
                        <ui-m040-c080-image-teaser
                            [headline]="d.headline"
                            [image]="d.image ?? { url: '' }"
                            [text]="d.text"
                            [description]="d.description"
                            [readLessText]="'Weniger anzeigen'"
                            [readMoreText]="'Mehr erfahren'"
                            [link]="d.itemType === 'service' ? d.link : undefined"
                            [linkText]="d.itemType === 'service' ? 'Termin vereinbaren' : undefined"
                            [firstBadge]="d.price ? d.priceLabel + ' ' + d.price : undefined"
                            [secondBadge]="'Empfehlung für Sie'"
                            [isFirstView]="true"
                            [queryParams]="{ service: d.id }"
                        />
                    </div>
                }
            </div>
            <div
                class="inner-page-wrapper grid w-full grid-cols-1 gap-x-16 gap-y-0 md:grid-cols-2 md:gap-x-[56px] md:gap-y-40 md:py-40 lg:grid-cols-3"
            >
                @for (item of campaign.afterSalesServicesMapped; track $index) {
                    @let secondFootnoteBadge =
                        item.isPriceNumber ? item.priceLabel + ' ' + item.price : item.price + '';
                    <ui-m040-c090-icon-text-card
                        [headline]="item.headline"
                        [text]="item.text"
                        [link]="item.link"
                        [queryParams]="{ service: item.id }"
                        [priceTags]="
                            item.price
                                ? [
                                      {
                                          text: secondFootnoteBadge,
                                      },
                                  ]
                                : undefined
                        "
                        [isFirstView]="false"
                    />
                }
            </div>
        </section>
    }
    @defer {
        @if (campaign.afterSalesAccesoriesCards && campaign.afterSalesAccesoriesCards.length > 0) {
            <section>
                <ui-m030-c030-shop-card-wrapper
                    [cards]="campaign.afterSalesAccesoriesCards"
                    [forceShowButton]="true"
                    [isFirstView]="false"
                >
                    <h2 headline>Online Zubehör-Katalog</h2>
                    <ng-container link>
                        @if (dealer().pages.shop; as url) {
                            <a
                                class="button-secondary md:w-auto"
                                [trackingElTarget]="url"
                                [hyundaiRouterLink]="url"
                                [queryParams]="{ utm_medium: 'dealer' }"
                                tracking
                                trackingElLabel="All Accessories Offer"
                                trackingElType="button"
                            >
                                Alle Zubehör-Angebote
                            </a>
                        }
                    </ng-container>
                </ui-m030-c030-shop-card-wrapper>
            </section>
        }

        <section>
            <app-global-contact isFirstView="false" />
        </section>
        @if (campaign.legalLines) {
            <section>
                <ui-m040-c020-rte [data]="campaign.legalLines" />
            </section>
        }
    }
}
